import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { heroData } from '../mockData';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToProducts = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="hero-section">
      {/* Flying birds */}
      <div className="bird bird-1" style={{ transform: `translateX(${scrollY * 0.3}px)` }}></div>
      <div className="bird bird-2" style={{ transform: `translateX(${scrollY * 0.2}px)` }}></div>
      <div className="bird bird-3" style={{ transform: `translateX(${scrollY * 0.25}px)` }}></div>
      <div className="bird bird-4" style={{ transform: `translateX(${scrollY * 0.15}px)` }}></div>
      <div className="bird bird-5" style={{ transform: `translateX(${scrollY * 0.35}px)` }}></div>
      <div className="bird bird-6" style={{ transform: `translateX(${scrollY * 0.28}px)` }}></div>

      {/* Bubbles */}
      <div className="bubble bubble-1"></div>
      <div className="bubble bubble-2"></div>
      <div className="bubble bubble-3"></div>
      <div className="bubble bubble-4"></div>
      <div className="bubble bubble-5"></div>
      <div className="bubble bubble-6"></div>
      <div className="bubble bubble-7"></div>
      <div className="bubble bubble-8"></div>

      {/* Logo */}
      <div className="hero-logo">
        <img className='h-20 w-auto' src="/logo-white.png" alt="" srcset="" />
      </div>

      {/* Content */}
      <div className="hero-content">
        <h1 className="hero-heading">
          {heroData.mainHeading}<br />
          <span className="hero-heading-accent">  <b className=''>{heroData.subHeading} Programação</b> </span>
        </h1>
        <p className="hero-tagline text-white">{heroData.tagline}</p>
      </div>

      {/* CTA */}
      <div className="hero-cta" onClick={scrollToProducts}>
        <p>{heroData.ctaText}</p>
        <ChevronDown className="cta-icon" size={24} />
      </div>
    </div>
  );
};

export default Hero;
